import { DataFetchingState } from '../dataFetching/generators';
import { GenericShopApiResponse } from 'Common/apiAdapters/types';

export const VALUE_PROPS_IDENTIFIER = 'VALUE_PROP_IDENTIFIER';

export enum ValuePropsType {
    DELIVERY = 'DELIVERY_INFORMATIONS',
    RETURN = 'HUNDRED_DAYS_RETURN',
    PHONE = 'PHONE_NUMBER',
}

export interface RemoteValueProp {
    name: string;
    link?: string;
    type: string;
    image: {
        file: {
            url: string;
        };
    };
}

export interface ValueProp {
    title: string;
    type: string;
    link?: string;
    imageSrc: string;
}

export type ValuePropsApiResponse = GenericShopApiResponse<RemoteValueProp[]>;
export interface ValuePropsState extends DataFetchingState {
    valueProps?: Array<ValueProp>;
}
